import * as React from "react";
import MaterialUIComboBox from "../../ComboBox/MaterialUIComboBox";

interface AircraftFilterProps {
  validAircraftList: string[];
  aircraftRegistrationValue: string;
  onAircraftValueChange: (aircraft: string) => void;
  onAircraftError: (isError: boolean) => void;
}

export const AircraftFilter: React.FC<AircraftFilterProps> = ({
  validAircraftList,
  aircraftRegistrationValue,
  onAircraftValueChange,
  onAircraftError
}) => {
  const [isErrorTail, setShowErrorTail] = React.useState(false);

  React.useEffect(() => {
    if (validAircraftList && validAircraftList.length > 0) {
      handleAircraft(aircraftRegistrationValue);
    }
  }, [validAircraftList, aircraftRegistrationValue]);

  const handleAircraft = (value: string) => {
    if (!value) value = "";
    let newTailNumber = value.toUpperCase();
    onAircraftValueChange(newTailNumber);

    const result =
      newTailNumber === "" || validAircraftList.includes(newTailNumber);
    if (result) {
      setShowErrorTail(false);
      onAircraftError(false);
    } else {
      setShowErrorTail(true);
      onAircraftError(true);
    }
  };

  return (
    <div className={validAircraftList != null ? "form-input dropdown" : "form-input"}>
      <MaterialUIComboBox
        label="Aircraft #"
        value={aircraftRegistrationValue}
        onChange={(_, value) => handleAircraft(value)}
        options={validAircraftList}
        className="aircraft-filter-combobox"
        freeSolo
        error={isErrorTail}
        helperText={isErrorTail ? "invalid entry" : ""}
        inputProps={{
          inputMode: "text",
          "data-testid": "aircraft-registration"
        }}
        noOptionsText="No matching option"
        data-testid="aircraft-filter"
        sx={{ minWidth: 300 }}
      />
    </div>
  );
};
export default AircraftFilter;
